import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#tjanster", label: "Tjänster", testid: "nav-services" },
  { href: "#varfor-oss", label: "Varför oss", testid: "nav-why-us" },
  { href: "#process", label: "Process", testid: "nav-process" },
  { href: "#faq", label: "FAQ", testid: "nav-faq" },
  { href: "#kontakt", label: "Kontakt", testid: "nav-contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#1A362B]/95 backdrop-blur-md border-b border-white/5"
          : "bg-[#1A362B]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 h-20 md:h-24 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-home"
          aria-label="Svea Ytservice AB — startsida"
          className="inline-flex items-center"
        >
          <span className="inline-flex items-center justify-center bg-white rounded-xl p-1.5 shadow-[0_2px_10px_rgba(0,0,0,0.2)]">
            <img
              src="/svea-logo.png?v=3"
              alt="Svea Ytservice AB logotyp"
              className="h-14 md:h-16 w-auto block"
              loading="eager"
              decoding="async"
            />
          </span>
          <span className="sr-only">Svea Ytservice</span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-[#F7F5F0]/80 hover:text-[#F7F5F0] text-sm tracking-wide transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#kontakt"
            data-testid="btn-nav-quote"
            className="inline-flex items-center bg-[#F7F5F0] text-[#1A362B] hover:bg-[#EAE5D9] transition-colors rounded-full px-5 py-2.5 text-sm font-medium"
          >
            Begär offert
          </a>
        </nav>

        <button
          className="md:hidden text-[#F7F5F0] p-2 -mr-2"
          aria-label="Öppna meny"
          data-testid="btn-mobile-menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-[#1A362B] border-t border-white/5 ${
          open ? "max-h-[480px]" : "max-h-0"
        }`}
      >
        <div className="px-6 pb-6 pt-2 flex flex-col gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={close}
              className="text-[#F7F5F0]/85 py-3 border-b border-white/5 text-base"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#kontakt"
            onClick={close}
            data-testid="btn-mobile-quote"
            className="mt-4 inline-flex items-center justify-center bg-[#F7F5F0] text-[#1A362B] rounded-full px-5 py-3 font-medium"
          >
            Begär offert
          </a>
        </div>
      </div>
    </header>
  );
}
